import type { BlogPostSummary } from "@/lib/blog/snapshot";
import { PostCard } from "./PostCard";

/** «اقرا كمان»: up to 3 compact cards picked server-side by selectRelated. Hidden when empty. */
export function RelatedPosts({ posts }: { posts: BlogPostSummary[] }) {
  if (!posts || posts.length === 0) return null;
  return (
    <section aria-labelledby="blog-related" className="mt-12 font-arabic">
      <h2 id="blog-related" className="text-xl font-bold text-gray-900 mb-4">
        اقرا كمان
      </h2>
      <div className="grid gap-4 md:grid-cols-3">
        {posts.slice(0, 3).map((post) => (
          <PostCard key={post.slug} post={post} compact />
        ))}
      </div>
    </section>
  );
}

export default RelatedPosts;
